<template>
  <div class="forgot">
    <adx-modal @modal-close="toggleModal" :type="`account`" :title="`Forgot Password`">
      <div slot="content" class="content">
        <div class="content__header">
          <div class="content__header--title">
            <p>Please enter the email address associated with your active account, and we’ll email you a link to reset your password.</p>
          </div>
        </div>
        <div class="content__input">
          <!-- <adx-input :label="`Email Address`" :icon="`icon-email`" />
          <button class="btn-block secondary signin">Send Reset Link</button> -->
          <adx-form
          @complete="onComplete($event)"
          :schema="schema"
          :model.sync="model"
          :error.sync="error"
          :onSubmit="onSubmit"
          :wrapper="wrapper" />
        </div>
        <div class="content__fulldivider">

        </div>
        <div class="content__footer">
          <div class="signup">
            <span @click="goToSignin">Back to sign in</span>
          </div>
        </div>
      </div>
    </adx-modal>
  </div>
</template>

<script>
import Modal from '@/components/Modal'
import Input from '@/components/Form/Input'
import Checkbox from '@/components/Form/Checkbox'
import FormAbstraction from '@/components/Form'

import api from '@/api'
import types from '@/lib/types'
import { apiV2 } from '@/api/urls'
const {
  ButtonType: { BUTTON, RESET },
  ButtonAction: { SUBMIT, APICALL, GOTO }
} = types


export default {
  name: 'adx-forgot-modal',
  components: {
    'adx-modal': Modal,
    'adx-input': Input,
    'adx-checkbox': Checkbox,
    'adx-form': FormAbstraction
  },
  props: {

  },
  data() {
    return {
      wrapper: {
        alertWrapper: `content`
      },
      model: {
        email: ``,
        password: ``,
        remember: ``
      },
      error: {

      },
      onSubmit: {
        wrapper: {
          class: ``
        },
        buttons: [
          {
            type: BUTTON,
            action: SUBMIT,
            label: `Send Reset Link`,
            uri: apiV2.forgot,
            params: this.model,
            method: `post`, // HTTP Method
            class: `btn-block primary not-rounded`,
            isLoading: false
          },
        ]
      },
      schema: [
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Email',
              model: 'email',
              method: 'onChange',
              validation: ['NotEmpty', 'Email']
            }
          ]
        }
      ]
    }
  },
  computed: {

  },
  watch: {

  },
  beforeCreate() {

  },
  created() {

  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    toggleModal() {
      this.$emit('toggle', 'toggleForgot')
    },
    goToSignin() {
      this.$emit('toggle', 'gotoSigninFromForgot')
    },
    onComplete ({ args }) {
      this.$emit('toggle', 'toggleForgot')
      const { data } = args
      const { message, redirect_to } = data
      this.$router.push({ path: redirect_to })
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>